import React, { FC } from "react";
import { AuthPageLayout } from "@/pages/auth/components";
import { Container, Grid } from "@mui/material";
import { RecoverPasswordForm } from "./";

/**
 * Recover Password Page
 */
export const RecoverPassword: FC = () => {
  return (
    <>
      <AuthPageLayout>
        <Container sx={{ width: "100%" }}>
          <Grid container spacing={1} sx={{ width: "100%" }}>
            <Grid size={{ xs: 12 }}>
              <RecoverPasswordForm />
            </Grid>
            <Grid size={{ xs: 12 }}></Grid>
          </Grid>
        </Container>
      </AuthPageLayout>
    </>
  );
};
